import { render, staticRenderFns } from "./ChannelManagerHotelConfig.vue?vue&type=template&id=cdef0a46&"
import script from "./ChannelManagerHotelConfig.vue?vue&type=script&lang=js&"
export * from "./ChannelManagerHotelConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdef0a46')) {
      api.createRecord('cdef0a46', component.options)
    } else {
      api.reload('cdef0a46', component.options)
    }
    module.hot.accept("./ChannelManagerHotelConfig.vue?vue&type=template&id=cdef0a46&", function () {
      api.rerender('cdef0a46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/ChannelManagerHotelConfig.vue"
export default component.exports